import React, { Component, ErrorInfo, ReactNode } from "react";
import { Box } from "@material-ui/core";
import clsx from "clsx";
import { ActionButton, NoResults } from "halifax";
import { RouteComponentProps, withRouter } from "react-router";
import { Maybe, TRIGGERED_ERROR_BOUNDARY } from "redmond";

import { buttonText, errorFallbackCopy } from "../../constants";
import { TRIPS_HOME } from "../../utils/paths";

import "./styles.scss";
import { trackEvent } from "../../api/v1/analytics/trackEvent";

export interface IErrorBoundaryProps extends RouteComponentProps {
  bookingId: Maybe<string>;
  children: ReactNode;
  isMobile: boolean;
}

export interface IErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<
  IErrorBoundaryProps,
  IErrorBoundaryState
> {
  static defaultProps: Partial<IErrorBoundaryProps> = {
    children: false,
    isMobile: false,
  };

  constructor(props: IErrorBoundaryProps) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(_error: any) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const { location } = this.props;

    if (process.env.NODE_ENV !== "production") {
      console.trace(errorInfo.componentStack);
    }

    trackEvent({
      eventName: TRIGGERED_ERROR_BOUNDARY,
      properties: {
        component_stack: errorInfo.componentStack,
        error_msg: error.message,
        error_name: error.name,
        error_stack: error.stack,
        location: location.pathname,
        location_search: location.search,
      },
    });
  }

  render() {
    const { bookingId, children, isMobile, history } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return (
        <Box className={clsx("exchange-error-fallback", { mobile: isMobile })}>
          <NoResults
            className="fallback-no-results"
            subtitle={errorFallbackCopy.SUBTITLE}
            title={errorFallbackCopy.TITLE}
          />
          <ActionButton
            className="fallback-action b2b"
            message={buttonText.BACK_BTN}
            onClick={() =>
              history.push({
                pathname: TRIPS_HOME,
                search: `?tripId=${bookingId}`,
              })
            }
          />
        </Box>
      );
    }

    return children;
  }
}

export default withRouter(ErrorBoundary);
